import React from 'react';
import classNames from 'classnames';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';

const CommonGridSpinner = ({customClassnames = ''}) => {
  return (
    <div className={classNames('h-50px d-flex justify-content-center', customClassnames)}>
      <img src={toAbsoluteUrl('/media/common/Spinner-apple_primary.svg')} alt="icon"/>
    </div>
  );
};

export default CommonGridSpinner;
